import isNil from 'lodash/isNil';
import minBy from 'lodash/minBy';
import { paymentMethodTypes } from '../../constants/paymentMethods';
import { getMethod } from '../../utils/paymentMethods';

const { BANK, CARD, WALLET } = paymentMethodTypes;

const getCheapestCardId = (paymentMethods) => {
  const cardMethod = paymentMethods.find((method) => method.type === CARD);
  const cards = cardMethod?.creditCards.map((card) => ({ id: card.id, price: card.price.value }));

  return minBy(cards, 'price')?.id;
};

export const getSelectedPaymentMethodId = (
  type,
  selectedCardId,
  selectedMainMethodId,
  paymentMethods,
) => {
  switch (type) {
    case CARD: {
      if (!isNil(selectedCardId)) {
        return selectedCardId;
      }

      return getCheapestCardId(paymentMethods);
    }
    case BANK:
    case WALLET: {
      return selectedMainMethodId;
    }
    default: {
      return null;
    }
  }
};

const getMethodCardOrBank = (method, id, subsectionCode) => {
  if (method.code === CARD) {
    return method.creditCards.find((option) => Number(option.id) === id);
  }

  if (method.code === BANK) {
    return method.banks.find((option) => Number(option.id) === id);
  }

  if (subsectionCode && method.options) {
    return method.options.find((option) => option.code === subsectionCode);
  }

  return method;
};

export const getSelectedPaymentMethod = (
  selectedPaymentMethodCode,
  type,
  id,
  commercialId,
  paymentMethods = [],
  subsectionCode = undefined,
) => {
  const method = getMethod(paymentMethods, selectedPaymentMethodCode);

  if (!type || !method) {
    return null;
  }
  const paymentItemId =
    commercialId !== null && selectedPaymentMethodCode === CARD ? commercialId : id;

  const paymentItem = getMethodCardOrBank(method, paymentItemId, subsectionCode);
  return paymentItem ? { ...paymentItem, type } : null;
};
